export const PAGINATION_DEFAULTS = {
  page: 1,
  limit: 25,
} as const;

export const MAX_PAGE_SIZE = 100;
